import { render, staticRenderFns } from "./mailingAddressMaintainDialog.vue?vue&type=template&id=bf6676de&scoped=true&"
import script from "./mailingAddressMaintainDialog.vue?vue&type=script&lang=js&"
export * from "./mailingAddressMaintainDialog.vue?vue&type=script&lang=js&"
import style0 from "./mailingAddressMaintainDialog.vue?vue&type=style&index=0&id=bf6676de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6676de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf6676de')) {
      api.createRecord('bf6676de', component.options)
    } else {
      api.reload('bf6676de', component.options)
    }
    module.hot.accept("./mailingAddressMaintainDialog.vue?vue&type=template&id=bf6676de&scoped=true&", function () {
      api.rerender('bf6676de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/mailingAddressMaintainDialog.vue"
export default component.exports